/**
 * Generated With: pnpm x packages/api/tools/generate-shopify-rest-model.ts https://shopify.dev/api/admin/rest/reference/inventory/location
 * API Version: 2022-01
 */

import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyCheckoutKey,
  ShopifyCheckoutToLocationKey,
  ShopifyFulfillmentKey,
  ShopifyFulfillmentOrderKey,
  ShopifyFulfillmentOrderToLocationKey,
  ShopifyFulfillmentServiceKey,
  ShopifyFulfillmentServiceToLocationKey,
  ShopifyFulfillmentToLocationKey,
  ShopifyInventoryItemKey,
  ShopifyInventoryItemToLocationsKey,
  ShopifyInventoryLevelKey,
  ShopifyInventoryLevelToInventoryItemKey,
  ShopifyInventoryLevelToLocationKey,
  ShopifyLocationKey,
  ShopifyLocationToInventoryItemsKey,
  ShopifyLocationToShopKey,
  ShopifyOrderKey,
  ShopifyOrderLineItemKey,
  ShopifyOrderLineItemToOriginLocationKey,
  ShopifyOrderToLocationKey,
  ShopifyOrderToRetailLocationKey,
  ShopifyOrderTransactionKey,
  ShopifyOrderTransactionToLocationKey,
  ShopifyRefundLineItemKey,
  ShopifyRefundLineItemToLocationKey,
  ShopifyShopKey,
} from "./keys";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";
import { ShopifyApiVersion } from "./ShopifyApiVersion";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyLocationKey,
  "2022-01": {
    name: "Shopify Location",
    graphQLTypename: "Location",
    fields: [
      {
        name: "Active",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "active" } },
      },
      {
        name: "Address 1",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "address1" } },
      },
      {
        name: "Address 2",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "address2" } },
      },
      {
        name: "City",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "city" } },
      },
      {
        name: "Country",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "country" } },
      },
      {
        name: "Country Code",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "country_code" } },
      },
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "id" } },
      },
      {
        name: "Fulfillments",
        fieldType: FieldType.HasMany,
        configuration: {
          relatedModelKey: ShopifyFulfillmentKey,
          inverseFieldKey: ShopifyFulfillmentToLocationKey,
        },
      },
      {
        name: "Fulfillment Services",
        fieldType: FieldType.HasMany,
        configuration: {
          relatedModelKey: ShopifyFulfillmentServiceKey,
          inverseFieldKey: ShopifyFulfillmentServiceToLocationKey,
        },
      },
      {
        name: "Inventory Items",
        fieldType: FieldType.HasManyThrough,
        key: ShopifyLocationToInventoryItemsKey,
        configuration: {
          joinModelKey: ShopifyInventoryLevelKey,
          relatedModelKey: ShopifyInventoryItemKey,
          inverseJoinModelFieldKey: ShopifyInventoryLevelToLocationKey,
          inverseRelatedModelFieldKey: ShopifyInventoryLevelToInventoryItemKey,
          inverseFieldKey: ShopifyInventoryItemToLocationsKey,
        },
      },
      {
        name: "Legacy",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "legacy" } },
      },
      {
        name: "Localized Country Name",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "localized_country_name" } },
      },
      {
        name: "Localized Province Name",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "localized_province_name" } },
      },
      {
        name: "Name",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "name" } },
      },
      {
        name: "Orders",
        fieldType: FieldType.HasMany,
        configuration: {
          relatedModelKey: ShopifyOrderKey,
          inverseFieldKey: ShopifyOrderToLocationKey,
        },
      },
      {
        name: "Order Line Items",
        fieldType: FieldType.HasMany,
        configuration: {
          relatedModelKey: ShopifyOrderLineItemKey,
          inverseFieldKey: ShopifyOrderLineItemToOriginLocationKey,
        },
      },
      {
        name: "Order Transactions",
        fieldType: FieldType.HasMany,
        configuration: {
          relatedModelKey: ShopifyOrderTransactionKey,
          inverseFieldKey: ShopifyOrderTransactionToLocationKey,
        },
      },
      {
        name: "Phone",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "phone" } },
      },
      {
        name: "Province",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "province" } },
      },
      {
        name: "Province Code",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "province_code" } },
      },
      {
        name: "Refunded Line Items",
        fieldType: FieldType.HasMany,
        configuration: {
          relatedModelKey: ShopifyRefundLineItemKey,
          inverseFieldKey: ShopifyRefundLineItemToLocationKey,
        },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "created_at" } },
      },
      {
        name: "Shopify Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "updated_at" } },
      },
      {
        name: "ZIP Code",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "zip" } },
      },
      {
        name: "Checkouts",
        fieldType: FieldType.HasMany,
        configuration: {
          relatedModelKey: ShopifyCheckoutKey,
          inverseFieldKey: ShopifyCheckoutToLocationKey,
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyLocationToShopKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "shop_id" } },
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: {
      type: "rest_list",
      resource: "location",
    },
  },
  "2022-10": {
    hasMetafields: true,
  },
  "2023-07": {
    fields: [
      {
        name: "Fulfillment Orders",
        fieldType: FieldType.HasMany,
        configuration: {
          relatedModelKey: ShopifyFulfillmentOrderKey,
          inverseFieldKey: ShopifyFulfillmentOrderToLocationKey,
        },
      },
    ],
  },
  "2024-07": {
    fields: [
      {
        name: "Retail Orders",
        fieldType: FieldType.HasMany,
        configuration: {
          relatedModelKey: ShopifyOrderKey,
          inverseFieldKey: ShopifyOrderToRetailLocationKey,
        },
      },
    ],
  },
};

export const ShopifyLocation = ({ apiVersion }: { apiVersion: ShopifyApiVersion }) => buildConnectionSpec(specs, apiVersion);
